export const zero = 0;
export const one = 1
export const two = 2;
export const three = 3;
export const four = 4;
export const five = 5;
export const six = 6;
export const seven = 7;
export const eight = 8;
export const nine = 9;
export const thirteen = 13;
export const fourteen = 14;
export const fifteen = 15;
export const twenty = 20;
export const twentyone = 21;
export const twentynine = 29;
export const thirty = 30;
export const fortyfour =44;
export const fortyfive = 45;
export const fortySeven = 47;

export const year2023 = 2023;
export const year2024 = 2024;
export const FirstJanuary2024 = '2024-01-01';

export const errorStatus401 = 401;

export const pageSize = 10;
export const maxAppId = 18;
export const minAppId = 8;
export const agentSanLength = 7;
export const tagsLength = 5;
export enum ApplicationStatus {
    CancelledApplication = 'Cancelled Application',
    InactivePolicy = 'Inactive Policy',
    ActivePolicy = 'Active Policy',
    FutureActivePolicy = 'Future Active Policy',
    PendedApplication = 'Pended Application',
    SubmittedApplication = 'Submitted Application',
    InProgressApplication = 'In Progress Application'
}

export enum StatusReason {
    AccretedWithCMS = 'Accreted with CMS',
    PlanTransition = 'Plan Transition',
    PolicyIssued = 'Policy Issued',
    NotAccretedWithCMS = 'Not Accreted with CMS'
}
